module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/3_d910563353e439034c3313513f874367.png";